const CSV_SEPARATOR = ';';

const escapeCsvValue = (value: unknown): string => {
  const raw = value === null || value === undefined ? '' : String(value);
  const escaped = raw.replace(/"/g, '""');
  return `"${escaped}"`;
};

export const buildCsvContent = (headers: string[], rows: Array<Array<unknown>>): string => {
  const normalizedRows = [headers, ...rows]
    .map((row) => row.map((value) => escapeCsvValue(value)).join(CSV_SEPARATOR))
    .join('\r\n');

  return `\uFEFF${normalizedRows}`;
};

export const downloadCsv = (filename: string, headers: string[], rows: Array<Array<unknown>>): void => {
  const blob = new Blob([buildCsvContent(headers, rows)], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export const buildTimestampSuffix = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${year}${month}${day}-${hours}${minutes}`;
};

